import {commitMutation, Disposable, Environment, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../MutationTypes';
import {
	UpdateGoogleCalendarInput,
	UpdateGoogleCalendarMutation,
	UpdateGoogleCalendarMutation$rawResponse,
} from './__generated__/UpdateGoogleCalendarMutation.graphql';

const mutation = graphql`
	mutation UpdateGoogleCalendarMutation($input: UpdateGoogleCalendarInput!) @raw_response_type {
		updateGoogleCalendar(input: $input) {
			googleCalendar {
				calendarViewPrivateEvents
				enabledCalendars
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<UpdateGoogleCalendarInput>,
	onSuccess: RelayOnCompleted<UpdateGoogleCalendarMutation>,
	onError: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	const optimisticResponse: UpdateGoogleCalendarMutation$rawResponse = {
		updateGoogleCalendar: {
			googleCalendar: {
				id: input.id as string,
				calendarViewPrivateEvents: input.viewPrivateEvents ?? null,
				enabledCalendars: input.enabledCalendarIds ?? null,
			},
		},
	};

	return commitMutation<UpdateGoogleCalendarMutation>(environment, {
		mutation,
		variables,
		optimisticResponse,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
